import { Button, Form, Input, message } from "antd";
import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { POST } from "../../utils/apiCalls";
import API from "../../config/api";

const ForgotPassword: React.FC = () => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const params = useParams();

  const onFinish = async (values: {
    newPassword: string;
    confirmPassword: string;
  }) => {
    if (values.newPassword !== values.confirmPassword) {
      message.error("Passwords do not match");
      return;
    }

    if (!params?.token) {
      message.error("Invalid or missing reset token");
      return;
    }

    setIsLoading(true);
    try {
      const response: any = await POST(API.ADMIN_RESET_PASSWORD, {
        token: params.token,
        newPassword: values.newPassword,
      });

      if (response?.status) {
        message.success(
          "Password reset successfully! You can now log in with your new password."
        );
        form.resetFields();
        setTimeout(() => {
          window.location.href = "/login";
        }, 2000);
      } else {
        message.error(
          response?.message || "Failed to reset password. Please try again."
        );
      }
    } catch (error: any) {
      message.error(
        error.response?.data?.message ||
          "Failed to reset password. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="LoginScreen">
      <Container>
        <Row>
          <Col sm={4} xs={12} />
          <Col sm={4} xs={12}>
            <div
              className="LoginScreen-Box"
              style={{
                padding: "40px",
                background: "#fff",
                borderRadius: "8px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
              }}
            >
              <div
                className="LoginScreen-txt1"
                style={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  textAlign: "center",
                  marginBottom: "24px",
                }}
              >
                Reset Password
              </div>
              <Form form={form} onFinish={onFinish} layout="vertical">
                <Form.Item
                  name="newPassword"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your new password",
                    },
                    {
                      min: 8,
                      message: "Password must be at least 8 characters long",
                    },
                    {
                      pattern:
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*?&]{8,}$/,
                      message:
                        "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                    },
                  ]}
                >
                  <Input.Password placeholder="New Password" size="large" />
                </Form.Item>
                <Form.Item
                  name="confirmPassword"
                  rules={[
                    { required: true, message: "Please confirm your password" },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("newPassword") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("Passwords do not match")
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password placeholder="Confirm Password" size="large" />
                </Form.Item>
                <Form.Item>
                  <Button
                    block
                    type="primary"
                    htmlType="submit"
                    size="large"
                    loading={isLoading}
                    style={{
                      borderRadius: "6px",
                      height: "48px",
                      fontSize: "16px",
                    }}
                  >
                    Submit
                  </Button>
                </Form.Item>
                <div
                  className="forgot-password-link"
                  onClick={() => {
                    window.location.href = "/login";
                  }}
                  style={{
                    textAlign: "center",
                    color: "#3b82f6",
                    cursor: "pointer",
                    marginTop: "16px",
                  }}
                >
                  Back to Login
                </div>
              </Form>
            </div>
          </Col>
          <Col sm={4} xs={12} />
        </Row>
      </Container>
    </div>
  );
};

export default ForgotPassword;
